import { Component, EventEmitter, Output } from '@angular/core'
import { UntypedFormControl, UntypedFormGroup } from '@angular/forms'
import { TranslateService } from '@ngx-translate/core'
import { HubtypeProviderAccount } from '../../../models/hubtype-provider-account'
import { processPhoneNumber } from '../../../utils/whatsapp-utils'

@Component({
  selector: 'app-channels-whatsapp-playground',
  templateUrl: './whatsapp-playground.component.html',
  styleUrls: ['./whatsapp-playground.component.scss'],
  standalone: false,
})
export class WhatsappPlaygroundComponent {
  phoneForm = new UntypedFormGroup({
    phone: new UntypedFormControl(''),
  })

  get titleText(): string {
    return this.translate.instant('shared.addChannels.whatsappPlayground.title')
  }
  get descriptionText(): string {
    return this.translate.instant(
      'shared.addChannels.whatsappPlayground.description'
    )
  }
  get whitelistInfoText(): string {
    return this.translate.instant(
      'shared.addChannels.whatsappPlayground.whitelistInfo'
    )
  }
  get whitelistTitleText(): string {
    return this.translate.instant(
      'shared.addChannels.whatsappPlayground.whitelistTitle'
    )
  }
  get exampleHintText(): string {
    return this.translate.instant(
      'shared.addChannels.whatsappPlayground.exampleHint'
    )
  }
  get connectButtonText(): string {
    return this.translate.instant(
      'shared.addChannels.whatsappPlayground.connectButton'
    )
  }
  get noteText(): string {
    return this.translate.instant('shared.addChannels.whatsappPlayground.note')
  }

  @Output() newChannel = new EventEmitter<HubtypeProviderAccount>()
  constructor(private translate: TranslateService) {}

  addWhatsappPlayground() {
    const allowed_user_phone = processPhoneNumber(this.phoneForm.value.phone)
    const provider = new HubtypeProviderAccount()
    provider.provider = HubtypeProviderAccount.WHATSAPP_PLAYGROUND
    provider.credentials_json = { allowed_user_phone }
    this.newChannel.emit(provider)
  }
}
